import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { LocalStoreService } from '../services/local-store.service';
import { MessageService } from 'src/app/@modules/components/message/message.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

	constructor(
		private auth: AuthService,
		private store: LocalStoreService,
		private router: Router,
		private messageService: MessageService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(catchError(err => {
			switch (err.status) {
				case 401:
					// auto logout if 401 response returned from api
					this.auth.signout();
					break;
				case 403:
					this.messageService.error("Unauthorized.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
					break;
				case 404:
					this.messageService.error("Not Found.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
					break;
				case 429:
					this.messageService.error("Too many Requests.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
					break;
				case 500:
					this.messageService.error("Something went wrong.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
					break;
				default:
					if (typeof err.message === 'string') {
						this.messageService.error(err.message, { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
					} else {
						this.messageService.error("Something went wrong.", {
							Position: 'bottom-right',
							Style: 'simple',
							Duration: 5000
						});
					}
			}

			// const error = err.error.message || err.statusText;
			return throwError(err.error.errors);
		}));
	}
}
